import { gql } from "gql";

export const GET_DICTIONARY = gql(/* GraphQL */ `
  query GetDictionaryValue($dictionary: Dictionaries!) {
    getDictionaryValues(dictionary: $dictionary) {
      values {
        id
        code
        value {
          value
        }
        description {
          value
        }
        style {
          textColor
          backgroundColor
        }
      }
      default {
        id
        code
        value {
          value
        }
      }
    }
  }
`);
